import { render, staticRenderFns } from "./TheResponsiblePersonList.vue?vue&type=template&id=10436c86&scoped=true&"
import script from "./TheResponsiblePersonList.vue?vue&type=script&lang=js&"
export * from "./TheResponsiblePersonList.vue?vue&type=script&lang=js&"
import style0 from "./TheResponsiblePersonList.vue?vue&type=style&index=0&id=10436c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10436c86",
  null
  
)

export default component.exports